<template>
  <div
    id="app"
    :class="{ 'bottom-img': !pageLoading }"
    v-hb-loading.fullscreen.lock="pageLoading"
    hb-loading-bg="#FFE3D5"
    hb-loading-circle-bg="#FFB58D"
    hb-loading-color="#ED234C"
    v-report.visit
  >
    <template v-if="!pageLoading">
      <PageNav v-if="isInHeybox" bg="#EB2349" :isFixed="true"></PageNav>
      <div class="activity-header">
        <DynamicBg></DynamicBg>
        <div
          class="rule-btn"
          :style="{ top: `${navHeight - 5}px` }"
          v-open-app
          @click="showRuleModal"
        >
          规则
        </div>
      </div>

      <SectionCollectCard
        v-open-app
        :act_id="act_id"
        :cc="collectCardInfo.cc"
        :cd="collectCardInfo.cd"
        :gc="gc"
        :gd="gd"
        :awardPoolList="awardPoolList"
        :devUserList="devUserList"
        @refreshData="getData"
        @pushToReceivedWishList="pushToReceivedWishList"
        @showTaskModal="showTaskModal"
      ></SectionCollectCard>

      <div
        class="activity-jumper gift-exchange"
        v-open-app
        @click="toGiftCard"
      ></div>

      <SectionAvatarDecoration
        v-open-app
        :act_id="act_id"
        :cc="receiveInfo.cc"
        :cd="receiveInfo.cd"
        :gd="gd"
        :followingIds="followingIds"
        :devUserList="devUserList"
        @refreshData="getData"
        @reload="reload"
      ></SectionAvatarDecoration>

      <SectionCreation v-open-app></SectionCreation>

      <div class="activity-jumper-title mall-sell"></div>
      <div
        class="activity-jumper mall-sell"
        v-open-app
        @click="toMallSell"
      ></div>

      <div class="activity-jumper-title animal-party"></div>
      <div
        class="activity-jumper animal-party"
        v-open-app
        @click="toAnimalParty"
      ></div>

      <div class="activity-jumper-title pubg"></div>
      <div class="activity-jumper pubg" v-open-app @click="toPubg"></div>
    </template>

    <FadeModal
      class="task-modal-wrapper"
      ref="task-modal"
      :gc="gc"
      :showCloseBtn="false"
    >
      <div class="task-modal-wrapper-content">
        <SectionTask
          :act_id="act_id"
          :cc="taskInfo.cc"
          :cd="taskInfo.cd"
          :gc="gc"
          :querys="querys"
          @taskHandler="taskHandler"
          @refreshData="getData"
          @scrollToAvatarDecoration="scrollToAvatarDecoration"
        ></SectionTask>
        <div class="front-mask"></div>
      </div>
    </FadeModal>

    <FadeModal
      class="rule-modal-wrapper"
      ref="rule-modal"
      title="活动规则"
      :gc="gc"
      title_color="#AF5E00"
    >
      <div class="rule-modal-wrapper-content">
        <div class="auth-content">
          <div class="auth-list">
            <p class="auth-item" v-for="(auth, index) in authList" :key="index">
              <span>{{ index + 1 }}.&nbsp;</span>
              <span>{{ auth }}</span>
            </p>
          </div>
        </div>
      </div>
    </FadeModal>
  </div>
</template>
<script>
import { uniq } from 'lodash';
import { executeProtocol, getParams, executeProtocolSync } from '_lib/utils';

import PageNav from '_com/base/page-nav/index.vue';
import DynamicBg from './components/dynamic-bg.vue';
import SectionCollectCard from './sections/section-collect-card.vue';
import SectionAvatarDecoration from './sections/section-avatar-decoration.vue';
import SectionCreation from './sections/section-creation.vue';
import SectionTask from './sections/section-task.vue';
import FadeModal from './components/fade-modal.vue';

import { getData, pollTask } from '_api/activity-common-template';
import { getFollowingIds } from '_api/account/profile';
import { getCommonJSON } from '_api/common.js';

const IS_PROD =
  process.env.NODE_ENV === 'production' &&
  window.location.href.includes('xiaoheihe');

export default {
  components: {
    PageNav,
    DynamicBg,
    SectionCollectCard,
    SectionAvatarDecoration,
    SectionCreation,
    SectionTask,

    FadeModal,
  },
  data() {
    return {
      navHeight: 88,
      pageLoading: true,
      isInHeybox: this.$hb_env.is_inapp,
      gc: {},
      gd: {},
      collectCardInfo: {
        cc: {},
        cd: {},
      },
      receiveInfo: {
        cc: {},
        cd: {},
      },
      taskInfo: {
        cc: {},
        cd: {},
      },
      lotteryInfo: {
        cc: {},
        cd: {},
      },
      querys: getParams(),
      act_id: IS_PROD ? '678df5362a5149d4bc4e51db' : '678db5b24b4f4148076d8ae4',
      receivedWishList: [],

      is_jump_from_task: '', // 跳转页面时的组件
      jump_from_task_ids: '', // 跳转页面时的id
      jump_from_act_id: '', // 跳转页面时任务的act_id
      task_poll_count: 0,
      followingIds: [],
      authList: [
        '本次“蛇舞新春 福满乾坤”活动的有效时间为2025年1月24日18:00至2025年2月6日23:59，抽奖机奖品合计发放600,000份，如奖品全部消耗完毕，活动将提前下线。本活动中获得的卡牌、抽奖次数仅可用于在本页面进行合成和抽奖，且仅限活动期限内使用，过期无效。',
        '本次活动可通过完成任务获取抽卡机会，抽取卡牌时每张卡牌出现的概率均为20%。此外，还可以通过好友互赠获取卡牌，每人每天仅限赠送3张卡牌，送出后无法撤回。可消耗5张不同卡牌合成一次抽奖机会并抽奖。',
        '「每日任务」将在活动期间每日00:00更新；「商城首单购买」任务仅限在小黑盒商城内购买游戏CDKEY（不包括预购游戏、Steam直购等）；非活动期间的浏览、分享、关注、购买等行为将无法完成任务。',
        '抽奖机中获得的游戏CDKEY及红包封面将以礼品卡的形式发放至“我-黑盒商城-我的钱包”中，请在礼品卡页面标识的有效期内兑换。H币及头像框奖励将自动发放至满足活动条件的对应小黑盒账号内。实物奖品将在地址信息收集结束后7个工作日内发货。',
        '受网络环境和参与人数的影响，任务状态可能存在延迟，将会在12小时内发放任务奖励。',
        '本次活动仅限小黑盒实名认证用户参与。活动期间，同一用户仅能参与一次，同一小黑盒账号ID、同一手机号、同一证件号、同一设备号等符合任一条件，均视为同一用户，以用户最早的参与活动记录为准。',
        '对于因用户自身网络、活动资格限制、奖品权益发放完毕、活动自动下线等非人为原因延误或导致用户无法成功参与活动的，小黑盒有权不对用户进行权益补偿。',
        '对于活动过程中违反活动规则、使用或涉嫌使用不正当方式如作弊、刷单等套取活动权益的用户，小黑盒有权取消该用户活动资格，追回已发放的权益并对该账号进行封禁处理，如给小黑盒造成损失的，小黑盒将保留向违规用户追索的权利。',
        '有疑问的用户可在“我-设置-帮助中心&问题反馈”中进行工单反馈。活动申诉期限为活动结束后10个工作日，逾期视为自动放弃该活动的申诉权利。',
      ],
      devUserList: [],
    };
  },
  computed: {
    awardPoolList() {
      const list = [
        { text: '隐秘', rarity: 1, list: [], probability: '' },
        { text: '传说', rarity: 2, list: [], probability: '' },
        { text: '史诗', rarity: 3, list: [], probability: '' },
        { text: '稀有', rarity: 4, list: [], probability: '' },
        { text: '祝福', rarity: 5, list: [], probability: '' },
      ];
      if (!this.lotteryInfo.cd.box_list) return list;
      this.lotteryInfo.cd.box_list.forEach((item) => {
        if (!list[item.rarity - 1].probability) {
          list[item.rarity - 1].probability =
            this.lotteryInfo.cc.probability[item.rarity];
        }
        if (item.rarity === 5) {
          if (list[4].list.length === 0 && item.name !== '谢谢参与') {
            list[4].list.push(item);
          }
        } else {
          list[item.rarity - 1].list.push(item);
        }
      });
      return list;
    },
  },
  created() {
    window.pageHiddenToOthersPage = () => {};
    window.pageHiddenToBackend = () => {};

    window.pageVisibleFromOthersPage = () => {
      this.reload();
    };
    window.pageVisibleFromBackend = () => {
      this.reload();
    };
    if (this.isInHeybox) {
      this.navHeight = Number(
        executeProtocolSync({ protocol_type: 'getNavigationBarHeight' }),
      );
    }

    Promise.all([this.getData(), this.getCommonJSON()]).then(() => {
      this.pageLoading = false;
    });
  },
  methods: {
    async getData() {
      return getData({
        act_id: this.act_id,
        is_share: !this.isInHeybox,
      }).then((res) => {
        if (res.data.status == 'ok') {
          const result = res.data.result;
          // console.log('getData', result);

          const collectCardCom = result.components_data.find(
            (item) => item.component_name === 'cpt-collect-card-v3',
          );
          this.collectCardInfo.cc = collectCardCom.component_conf;
          this.collectCardInfo.cd = collectCardCom.component_data;
          const receiveCom = result.components_data.find(
            (item) => item.component_name === 'cpt-receive',
          );
          this.receiveInfo.cc = receiveCom.component_conf;
          this.receiveInfo.cd = receiveCom.component_data;
          const taskCom = result.components_data.find(
            (item) => item.component_name === 'cpt-task',
          );
          this.taskInfo.cc = taskCom.component_conf;
          this.taskInfo.cd = taskCom.component_data;

          const lotteryCom = result.components_data.find(
            (item) => item.component_name === 'cpt-lottery-v2',
          );
          this.lotteryInfo.cc = lotteryCom.component_conf;
          this.lotteryInfo.cd = lotteryCom.component_data;

          this.gc = result.common_config;
          this.gd = result.common_data;

          // this.pageLoading = false
        } else {
          // this.$toast(res.data.message)
        }
      });
    },
    pushToReceivedWishList(userid) {
      this.followingIds.push(userid);
    },
    async getCommonJSON() {
      const {
        data: { status, result },
      } = await getCommonJSON({
        object_id: window.location.origin.includes('web.xiaoheihe')
          ? '6791a58b6d2745c0a30de797'
          : '6791a5b96f495ffc6dbdd929',
      });
      if (status !== 'ok') {
        return;
      }
      const json = JSON.parse(result.json_data || '{}');
      const ids = uniq(json.map((item) => item.heybox_id));

      this.devUserList = json.slice();
      if (this.isInHeybox) {
        await this.getFollowState(ids.join(','));
      }
    },

    showRuleModal() {
      this.$refs['rule-modal'].showModal();
    },
    hideRuleModal() {
      this.$refs['rule-modal'].hideModal();
    },

    showTaskModal() {
      this.$refs['task-modal'].showModal();
    },
    hideTaskModal() {
      this.$refs['task-modal'].hideModal();
    },

    taskHandler({ is_jump_from_task, jump_from_task_ids, jump_from_act_id }) {
      this.is_jump_from_task = is_jump_from_task;
      this.jump_from_task_ids = jump_from_task_ids;
      this.jump_from_act_id = jump_from_act_id;
    },
    pollTask() {
      if (this.req_lock) {
        setTimeout(() => {
          this.pollTask();
        }, 200);
        return;
      }
      this.req_lock = true;
      this.task_poll_count++;
      let task_params = {
        act_id: this.jump_from_act_id,
        _notip: true,
      };
      if (this.jump_from_task_ids) {
        task_params.task_ids = this.jump_from_task_ids;
      }
      pollTask(task_params)
        .then((res) => {
          this.req_lock = false;
          if (res.data.status == 'ok') {
            var data = res.data.result && res.data.result.data;
            // 任务完成了
            if (
              data &&
              data[this.jump_from_task_ids] &&
              data[this.jump_from_task_ids].state == 1
            ) {
              this.jump_from_task_ids = '';
              this.jump_from_act_id = '';
              this.is_jump_from_task = false;
              this.task_poll_count = 0;

              this.getData();
            } else {
              // 没完成继续请求
              if (this.task_poll_count >= 5) {
                this.task_poll_count = 0;
                this.jump_from_task_ids = '';
                this.jump_from_act_id = '';
                this.is_jump_from_task = false;
                this.getData();
              } else {
                setTimeout(() => {
                  this.pollTask();
                }, [200, 200, 500, 800, 1200, 1500][this.task_poll_count]);
              }
            }
          } else {
            this.task_poll_count = 0;
          }
        })
        .catch(() => {
          this.task_poll_count = 0;
        });
    },
    reload() {
      if (this.is_jump_from_task) {
        this.pollTask();
      } else {
        setTimeout(() => {
          this.getData();
        }, 200);
      }
    },
    async getFollowState(ids) {
      return getFollowingIds({
        user_ids: ids,
      }).then((res) => {
        if (res.data.status == 'ok') {
          const result = res.data.result;
          this.followingIds = result.following;
        }
      });
    },
    toGiftCard() {
      executeProtocol({
        protocol_type: 'openBBSTag',
        tag: '新年赠卡专区',
      });
    },
    toMallSell() {
      executeProtocol({
        protocol_type: 'openWindow',
        full_screen: true,
        status_bar: {
          style: 'light',
        },
        navigation_bar: {
          title: '‎',
          color: '#ffffff',
          right_icon: {
            enabled: true,
            protocol: {
              protocol_type: 'share',
              title: '喜迎乙巳春，黑盒大促来袭！',
              desc: '灵蛇衔福至，盛惠闹春潮。《荒野大镖客2》《生化危机4》史低贺岁中！',
              share_url:
                'https://api.xiaoheihe.cn/game/h20250121_activity/v2?act_id=678f5ac79b3b5bfad299fac5&is_share=1',
              img_url:
                'https://imgheybox.max-c.com/oa/2025/01/22/51ab48a929f20d8604e7a7978614518e.png',
            },
          },
        },
        webview: {
          url: 'https://api.xiaoheihe.cn/game/h20250121_activity/v2?act_id=678f5ac79b3b5bfad299fac5',
          pull: false,
          refresh: false,
        },
      });
    },
    toPubg() {
      executeProtocol({
        protocol_type: 'openWindow',
        full_screen: true,
        status_bar: {
          style: 'light',
        },
        navigation_bar: {
          title: '‎',
          // color: '#ffffff',
          // right_icon: {
          //   enabled: true,
          //   protocol: {
          //     protocol_type  : 'share',
          //     title: '喜迎乙巳春，黑盒大促来袭！',
          //     desc: '灵蛇衔福至，盛惠闹春潮。《荒野大镖客2》《生化危机4》史低贺岁中！',
          //     share_url: 'https://api.xiaoheihe.cn/game/h20250123_activity/v2?act_id=6792016c47e4e2d94a4acd67',
          //     img_url: 'https://imgheybox.max-c.com/oa/2025/01/22/51ab48a929f20d8604e7a7978614518e.png'
          //   }
          // }
        },
        webview: {
          url: 'https://api.xiaoheihe.cn/game/h20250123_activity/v2?act_id=6792016c47e4e2d94a4acd67',
          pull: false,
          refresh: false,
        },
      });
    },
    toAnimalParty() {
      executeProtocol({
        protocol_type: 'openWindow',
        full_screen: true,
        navigation_bar: {
          title: '‎',
          right_icon: {
            enabled: true,
            protocol: {
              protocol_type: 'share',
              title: '小黑盒 | 猛兽派对新春大吉',
              desc: '参与新春限时活动，赢联名皮肤&超多周边好礼！',
              share_url:
                'https://api.xiaoheihe.cn/game/h20250120_activity/v2?act_id=678dbbe13eccc4e4f8191edb',
              img_url:
                'https://imgheybox.max-c.com/oa/2025/01/23/52f22cb2db1921b73b0358073108d9ca.png',
            },
          },
        },
        webview: {
          url: 'https://api.xiaoheihe.cn/game/h20250120_activity/v2?act_id=678dbbe13eccc4e4f8191edb',
        },
      });
    },
    scrollToAvatarDecoration() {
      this.hideTaskModal();
      setTimeout(() => {
        const el = document.querySelector('.section-avatar-decoration');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
    },
  },
};
</script>
<style lang="less">
@import '~_style/common.css';

html,
body {
  background: #ffe3d5;
}

#app {
  width: 100%;
  min-height: 100vh;
  max-width: 480px;
  background: #ffe3d5;
  margin: 0 auto;
  padding-bottom: 140px;
  &.bottom-img {
    background:
      center bottom -25px ~'/' 100% auto
        url(https://imgheybox.max-c.com/oa/2025/01/20/3d0754f884e65d55d6967604d4ced8c8.png)
        no-repeat,
      center bottom 59px ~'/' 130px 18px
        url(https://imgheybox.max-c.com/oa/2025/01/21/5c6e05b05ba4315f53df310c3122d505.png)
        no-repeat;
  }
}
.activity-header {
  position: relative;
  width: 100%;
  // padding-top: calc(320 / 375 * 100%);
  // background: center / 100% 100% url(https://imgheybox.max-c.com/oa/2025/01/20/9252a99ad7a63f787190c9752d5bdeea.png) no-repeat;
  .rule-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 7px;
    top: 0;
    width: 58px;
    height: 42px;
    color: #ffffffcc;
    font-size: 18px;
    line-height: 25px;
    background: #00000033;
    border-radius: 14px;
    transform: scale(0.5);
    transform-origin: right top;
  }
}
.section-title {
  width: 100%;
  height: auto;
}
.activity-jumper-title {
  width: calc(100% - 24px);
  margin: 0 12px;
  padding-top: calc(57 / 351 * 100%);
  margin-top: 30px;
  &.mall-sell {
    background: center / auto 100%
      url(https://imgheybox.max-c.com/oa/2025/01/21/320464f9217c7260621a2dcfd319eab1.png)
      no-repeat;
  }
  &.animal-party {
    background: center / auto 100%
      url(https://imgheybox.max-c.com/oa/2025/01/21/f753fb93584bb93f987de66d2bae3973.png)
      no-repeat;
  }
  &.pubg {
    background: center / auto 100%
      url(https://imgheybox.max-c.com/oa/2025/01/24/69e0cea2828bb8cc88b91ce6a52e2f81.png)
      no-repeat;
  }
}
.activity-jumper {
  width: calc(100% - 24px);
  margin: 0 12px;
  &.gift-exchange {
    padding-top: calc(88 / 375 * 100%);
    background: center / 100% 100%
      url(https://imgheybox.max-c.com/oa/2025/01/20/c0dc2f85bf2bdce7c54718a1bd880e89.png)
      no-repeat;
  }
  &.mall-sell {
    border-radius: 12px;
    overflow: hidden;
    padding-top: calc(120 / 375 * 100%);
    background: center / 100% 100%
      url(https://imgheybox.max-c.com/oa/2025/01/22/7ac708208ddf4d6b1461c053ddfd1d80.png)
      no-repeat;
    margin-top: 6px;
  }
  &.animal-party {
    border-radius: 12px;
    overflow: hidden;
    padding-top: calc(120 / 375 * 100%);
    background: center / 100% 100%
      url(https://imgheybox.max-c.com/oa/2025/01/23/3a12b73c70b43e3060e20029957c30db.png)
      no-repeat;
    margin-top: 6px;
  }
  &.pubg {
    border-radius: 12px;
    overflow: hidden;
    padding-top: calc(120 / 375 * 100%);
    background: center / 100% 100%
      url(https://imgheybox.max-c.com/oa/2025/01/24/a1e6b412cacc00111aa1bfff79698c96.png)
      no-repeat;
    margin-top: 6px;
  }
}
.body-fixed {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.task-modal-wrapper {
  .fade-modal-box {
    padding-top: calc((198 / 1125 * 100%) + 6px);
    background:
      center top / 100% auto
        url(https://imgheybox.max-c.com/oa/2025/01/21/a705254276e25dcacfd4bb5d9e83fcd3.png)
        no-repeat,
      center top 60px ~'/' 100% 100%
        linear-gradient(180deg, #d61035 0%, #ea2349 52%, #ff9a93 100%) no-repeat;
  }
  .task-modal-wrapper-content {
    position: relative;
    .front-mask {
      position: fixed;
      left: 50%;
      bottom: 0;
      width: 100%;
      max-width: 480px;
      height: 107px;
      background: center / 100% 100%
        url(https://imgheybox.max-c.com/oa/2025/01/20/3d0754f884e65d55d6967604d4ced8c8.png)
        no-repeat;
      transform: translateX(-50%);
    }
  }
}
.rule-modal-wrapper {
  .fade-modal-box {
    background: #fff1e1;
    border-radius: 12px 12px 0 0;
    max-height: 60vh;
    height: auto;
    padding-top: 0;
    .title-box {
      width: 100%;
      height: 48px;
      color: #af5e00;
      text-align: center;
      font-size: 18px;
      font-weight: 500;
      line-height: 28px;
      padding-top: 20px;
      background: #fff1e1;
      .title {
        margin: 0;
      }
    }
    .btn-close {
      top: 20px;
    }
    .rule-modal-wrapper-content {
      padding-bottom: 34px;
      .auth-content {
        .auth-list {
          width: 100%;
          overflow: auto;
          padding: 8px 12px;
          margin: 8px 0;
          .auth-item {
            display: flex;
            > span {
              color: #af5e00;
              font-size: 13px;
              line-height: 19px;
            }
          }
        }
      }
    }
  }
}
</style>
